module.exports = __webpack_public_path__ + "img/fiveStar.a50d5351.png";